import { useExperiments } from '@wix/yoshi-flow-editor';
import { deserializeMenusDisplayOrder, serializeMenusDisplayOrder } from 'root/utils/menusDisplayOrderChunking';
import type { MenuOrder } from 'root/components/Menus/Settings/Tabs/MenusTab/MenusSettingsParams';

export const useMenuReordering = () => {
  const { experiments } = useExperiments();
  const useChunking = experiments.enabled('specs.restaurants.livesiteOOIReorderMenus');

  return {
    deserializeMenusDisplayOrder,
    serializeMenusDisplayOrder: (menus: MenuOrder[]) => serializeMenusDisplayOrder(menus, useChunking),
  };
};
